import React from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';
import { colors } from '../../../../../../../services/utilityFunctions';
import InboxMessageProp from '../../../../../propTypes/inboxMessageProp';
import InboxContainer from '../InboxContainer';

export default function InfoMessage({ message, onClick }) {
  const { title, info, image, createdAt } = message;

  return (
    <InboxContainer
      style={{
        '--news-item-bg': colors('dynamic'),
        '--news-item-title': colors('inverse'),
        '--news-item-text': colors('inverse'),
      }}
      title={title}
      createdAt={createdAt}
      onClick={onClick}
    >
      <div className="news-item-content-with-image">
        <div className="news-item-content-text">
          <Linkify>{info}</Linkify>
        </div>
        {!!image?.thumb && (
          <img
            src={image.thumb}
            className="news-item-content-image"
            alt="info"
          />
        )}
      </div>
    </InboxContainer>
  );
}

InfoMessage.propTypes = {
  message: PropTypes.shape(InboxMessageProp.propType).isRequired,
  onClick: PropTypes.func.isRequired,
};
